import { loadStripe } from "@stripe/stripe-js";

/**
 * One Stripe.js load per document. A second `loadStripe` yields a second Stripe
 * instance, and Elements created by one cannot be confirmed by the other — it
 * fails only at confirm time, with an opaque error.
 */
export const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
);
